module.exports = __webpack_public_path__ + "img/bitrix24.7dc6b2fa.png";